import { Routes } from '@angular/router';
import { Home } from './components/home/home';
import { RequestDetails } from './components/request-details/request-details';
import { DiffView } from './components/diff-view/diff-view';
import { Settings } from './components/admin/settings/settings';
import { SkillsManager } from './components/admin/skills/skills-manager';
import { AiSettings } from './components/admin/ai-settings/ai-settings';
import { GithubSettings } from './components/admin/github-settings/github-settings';
import { PersonalTokens } from './components/admin/personal-tokens/personal-tokens';
import { Reports } from './components/admin/reports/reports';
import { canActivateAuthRole } from './guards/keycloak.guard';
import { authGuard } from './guards/auth.guard';
import { unsavedChangesGuard } from './guards/unsaved-changes.guard';

export const routes: Routes = [
  {
    path: '',
    component: Home,
    canActivate: [authGuard],
    data: { role: 'manage-account' },
  },
  {
    path: 'search',
    component: RequestDetails,
    canActivate: [canActivateAuthRole, authGuard],
    data: { role: 'manage-account' },
  },
  {
    path: 'diff',
    component: DiffView,
    canActivate: [canActivateAuthRole, authGuard],
    data: { role: 'manage-account' },
  },
  {
    path: 'admin/settings',
    component: Settings,
    canActivate: [canActivateAuthRole, authGuard],
    data: { role: 'manage-account' },
    children: [
      { path: '', redirectTo: 'ai', pathMatch: 'full' },
      { path: 'ai', component: AiSettings, canDeactivate: [unsavedChangesGuard] },
      { path: 'templates', component: SkillsManager, canDeactivate: [unsavedChangesGuard] },
      { path: 'github', component: GithubSettings },
      { path: 'tokens', component: PersonalTokens },
    ],
  },
  {
    path: 'admin/reports',
    component: Reports,
    canActivate: [canActivateAuthRole, authGuard],
    data: { role: 'manage-account' },
  },
  // Back-compat: the old standalone routes now live as Settings tabs.
  { path: 'admin/skills', redirectTo: 'admin/settings/templates' },
  { path: 'admin/ai-settings', redirectTo: 'admin/settings/ai' },
  { path: '**', redirectTo: '' },
];
